import Iridescence from "../../components/Iridescence.jsx";
import useAuth from "../../hooks/useAuth";
import useRoutes from "../../hooks/useRoutes";
import { Link, Route, Routes } from "react-router-dom";
import CustomNavigate from "../../components/CustomNavigate";

export default function AuthLayout() {
  const { user, logout } = useAuth();
  const { getRoutes } = useRoutes("/auth");

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center relative `}
    >
      <Link to="/auth" onClick={user && logout} className="mb-6">
      <img src="/logo/engage-white.svg" alt="Engage Logo" className="" />
      </Link>

      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg">
        <Routes>
          {getRoutes()}
          <Route path="*" element={<CustomNavigate to="/auth/login" replace />} />
        </Routes>
      </div>
      <Iridescence
          className="absolute top-0 left-0 w-full h-full -z-50 pointer-events-none"
          color={[0.2,0.45,0.8]}
          mouseReact
          amplitude={0.5}
          speed={0.1}
        />
    </div>
  );
}
